import { Grid, Typography } from '@mui/material';
import axios from 'axios';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import '../../styles/bible.css';

export default function Verses() {
    const [verses, setVerses] = useState('');
    const params = useParams();
    const bibleId = params?.version;
    const chapterId = params?.chapter;

    useEffect(() => {
        axios
            .get(
                `https://api.scripture.api.bible/v1/bibles/${bibleId}/chapters/${chapterId}?include-titles=true&include-verse-spans=true`,
                {
                    headers: {
                        'api-key': '74d66efbae53bab5516e6c50cbaf17ea',
                    },
                }
            )
            .then((resp) => {
                setVerses(resp?.data?.data?.content);
            });
    }, [bibleId, chapterId]);

    return (
        <Screen loading={verses.length} authPass title={`Verses`}>
            <Grid item xs={12}>
                <Typography>{chapterId}</Typography>
                <div className="text-justify">{parse(verses)}</div>
            </Grid>
        </Screen>
    );
}
